export default __webpack_public_path__ + "static/media/bg-missing-preview.c54add4f.jpg";